import {useMutation} from "react-query";
import apis from "services";
import {useSnackbar} from "notistack";
import EventEmitter from "reactjs-eventemitter";

export default function useSendMessage(handleReset) {
    const {enqueueSnackbar} = useSnackbar();
    const {mutate: sendMessage} = useMutation('send_message', apis.sendMessageApi, {
        onSuccess: async ({data}) => {
            if (data.status) {
                //TODO =:: invalidateQuery not working
                await enqueueSnackbar("Message Sent", {variant: "success"});
                EventEmitter.emit('refetch-messages');
            }
        },
        onError: (errors) => {
            console.log('ERROR ->', errors);
            enqueueSnackbar("Message Sending Failed", {variant: "error"})
        }
    });

    return [sendMessage]
}